module.exports = __webpack_public_path__ + "static/media/A8.6e02dc68.jpg";